var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartInvoicingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 200",
    width: 600,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 120,
    height: 140,
    rx: 15,
    ry: 15,
    fill: "none",
    stroke: "#1E9AD8",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 20 L120 50 L90 20 Z",
    fill: "#1E9AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 20 L120 50",
    stroke: "#1E9AD8",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#1E9AD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#1E9AD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#1E9AD8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 120,
    r: 25,
    fill: "#00A266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 120 L72 127 L85 110",
    stroke: "white",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 140,
    width: 8,
    height: 15,
    fill: "#00A266"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 130,
    width: 8,
    height: 25,
    fill: "#00A266"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 135,
    width: 8,
    height: 20,
    fill: "#00A266"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 125,
    width: 8,
    height: 30,
    fill: "#00A266"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(215, 45)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: 700,
    fill: "#173B64"
  }, "Smart"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(215, 100)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: 700,
    fill: "#00A266"
  }, "Invoicing"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartInvoicingLogo);
export default __webpack_public_path__ + "static/media/smart-invoicing-logo.0229d2c6f0fa8d035f89d59816ce09ba.svg";
export { ForwardRef as ReactComponent };